import { Checkbox, Tooltip } from '@blueprintjs/core';
import styles from './Lender.module.css';
import { ChangeEventHandler, useCallback, useMemo } from 'react';
import { AvailableLender } from '../IAvailableLenders';
import { useFormContext } from 'react-hook-form';
import { ApplicationDataFormValues } from '../../ApplicationData/ApplicationDataForm/ApplicationDataFormSchema';

export interface ILenderTierHeader {
  tier: string;
  lenders: AvailableLender[];
}

export function LenderTierHeader({ tier, lenders }: ILenderTierHeader) {
  const { watch, setValue } = useFormContext<ApplicationDataFormValues>();

  const enabledLenders = useMemo(
    () => lenders.filter((lender) => !lender.state.disabled),
    [lenders],
  );

  const selectedLenders = watch('SelectedLenders');

  const checked = useMemo(
    () =>
      enabledLenders.length > 0 &&
      enabledLenders.every(({ lenderID }) => selectedLenders.has(lenderID)),
    [enabledLenders, selectedLenders],
  );

  const handleOnChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      if (e.target.checked) {
        enabledLenders.forEach(({ lenderID }) => selectedLenders.add(lenderID));
      } else {
        enabledLenders.forEach(({ lenderID }) =>
          selectedLenders.delete(lenderID),
        );
      }
      setValue('SelectedLenders', selectedLenders);
    },
    [enabledLenders, selectedLenders, setValue],
  );

  return (
    <div className={styles.headerContainer} data-variant={tier}>
      <Tooltip
        disabled={enabledLenders.length > 0}
        content="No eligible lenders"
      >
        <Checkbox
          labelElement={
            tier === '0' ? (
              <strong>Secured Banks</strong>
            ) : (
              <strong>Tier {tier}</strong>
            )
          }
          className={styles.checkbox}
          disabled={enabledLenders.length === 0}
          checked={checked}
          onChange={handleOnChange}
        />
      </Tooltip>
    </div>
  );
}
